import React from "react";
import logo from "../../Images/logo.png";
import { useTranslation } from "react-i18next";

const Error = () => {
  const { t: translator } = useTranslation();
  return (
    <>
      <nav className="navbar navbar-expand-lg brand-color">
        <span className="navbar-brand pl-4">
          <img src={logo} alt="logo" id="logo" />
        </span>
        <ul className="navbar-nav ml-auto pr-4">
          <li className="text-light text-uppercase">
            <span>{translator("Error-LiveTogether")}</span>
          </li>
        </ul>
      </nav>
      <div className="col-lg-4" style={{ margin: "130px auto" }}>
        <h5 className="text-center text-uppercase teleServiceName">
          <strong>{translator("Error-Msg")}</strong>
        </h5>
      </div>
    </>
  );
};

export default Error;
